import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { AccountType, DashboardType } from "@front/m19-api-client";
import { inject } from "@angular/core";

export function dashboard360lastSelectedGuard(dashboardType: DashboardType): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);

    const accountId: string = route.queryParams["accountId"] ?? "";
    const accountType = accountId.startsWith("ENTITY") ? AccountType.VENDOR : AccountType.SELLER;

    const currentUrlFragments = route.pathFromRoot.flatMap((s) => s?.url ?? []).map((s) => s.path);

    const lastSelectedDashboardIdFromLocalStorage = localStorage.getItem(
      getLastSelectedDashboardKey(accountType, dashboardType),
    );
    const lastSelectedDashboardId = Number(lastSelectedDashboardIdFromLocalStorage);

    if (lastSelectedDashboardId && !isNaN(lastSelectedDashboardId)) {
      return redirectToDashboardView(router, route, currentUrlFragments, lastSelectedDashboardId);
    } else {
      return redirectToDashboardList(router, route, currentUrlFragments);
    }
  };
}

function redirectToDashboardView(
  router: Router,
  route: ActivatedRouteSnapshot,
  fragments: string[],
  dashboardId: number,
) {
  return router.createUrlTree([...fragments, "dashboard", dashboardId], {
    queryParamsHandling: "merge",
    queryParams: route.queryParams,
  });
}

export function redirectToDashboardList(router: Router, route: ActivatedRouteSnapshot, fragments: string[]) {
  return router.createUrlTree([...fragments, "dashboard-list"], {
    queryParamsHandling: "merge",
    queryParams: route.queryParams,
  });
}

export function getLastSelectedDashboardKey(accountType: AccountType, dashboardType: DashboardType) {
  const prefix = dashboardType === DashboardType.ACCOUNT_MARKETPLACE ? "a360" : "p360";
  return `${prefix}_lastSelectedDashboard_${accountType}`;
}
